import SimpleAlert from "../alerts/SimpleAlert";

export function createPostFieldsValidator({
    name,
    email,
    contact,
    linkedInUrl,
    qualification,
    institution,
    city,
    selectedOption,
    goals,
    transectionId,
    paymentProof }) {

    if (!name) {
        SimpleAlert("Name field is required", "", "error");
        return true;
    }
    if (!email) {
        SimpleAlert("Email field is required", "", "error");
        return true;
    }
    if (!contact) {
        SimpleAlert("Contact field is required", "", "error");
        return true;
    }

    if (!qualification) {
        SimpleAlert("Qualification field is required", "", "error");
        return true;
    }
    if (!institution) {
        SimpleAlert("Institutaion name field is required", "", "error");
        return true;
    }
    if (!city) {
        SimpleAlert("City name field is required", "", "error");
        return true;
    }
    if (!selectedOption) {
        SimpleAlert("Basic knowledge field is required", "Please let us know that you have the basic knoledege of not", "error");
        return true;
    }
    if (!paymentProof) {
        SimpleAlert("Payment proof uplaod required", "Please upload the paymemnt success screenshot", "error");
        return true;
    }
    if (!goals) {
        SimpleAlert("Goals field is required", "", "error");
        return true;
    }
    if (!transectionId) {
        SimpleAlert("Transection ID field is required", "", "error");
        return true;
    }


}